import type { ResponseDto } from '@app/api/dtos'
import type { ContractorsClusterDto } from '@app/api/routes/contractors/dtos'
import type { ConnectionsContractorsDataSource } from '../types'
import type { TableData } from '@app/types/table'

export const adaptConnectionsContractorsTableData = (
  contractorsClusterResponse: ResponseDto<ContractorsClusterDto>
): TableData<ConnectionsContractorsDataSource> => {
  const { count, results: contractorsCluster } = contractorsClusterResponse

  const dataSource: ConnectionsContractorsDataSource[] = contractorsCluster.map(dto => ({
    key: dto.id,
    monitoringType: dto.monitoringType.name,
    cluster: dto.cluster.name,
    contractors: dto.contractor.name
  }))

  return { count, dataSource }
}
